import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { UtilsEdit } from "@easy/ui/utils";
import { useRenderPreviewStore } from "@/views/store/render-preview.store";
import { storeToRefs } from "pinia";


export default /*@__PURE__*/_defineComponent({
  __name: 'cUtilsEdit',
  emits: ["edit"],
  setup(__props) {

const renderPreviewStore = useRenderPreviewStore();
const { isPreview, isPageMode } = storeToRefs(renderPreviewStore);



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(UtilsEdit), {
    enabled: _unref(isPreview) && !_unref(isPageMode),
    onEdit: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('edit')))
  }, {
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 3
  }, 8, ["enabled"]))
}
}

})